import { render, staticRenderFns } from "./ItemPopupSample.vue?vue&type=template&id=e1737e28"
import script from "./ItemPopupSample.vue?vue&type=script&lang=js"
export * from "./ItemPopupSample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports